import { DEFAULT_ITEMS_PER_PAGE } from "@/config";
import { useSearchParams } from "@/hooks";
import { Select } from "../forms";

export default function ItemsPerPageSelector({
  label,
  options = [10, 25, 50, 100],
  defaultValue = DEFAULT_ITEMS_PER_PAGE,
}) {
  const { setParams, getParam } = useSearchParams();

  const itemsPerPage = getParam("perPage") ?? defaultValue;

  const handleItemsPerPageChange = (event) => {
    setParams({ page: 1, perPage: event.target.value });
  };

  return (
    <div className="flex items-center">
      <Select
        className="max-w-20"
        value={itemsPerPage}
        onChange={handleItemsPerPageChange}
      >
        {options.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </Select>

      <label className="shrink-0 pl-2 text-sm font-medium text-gray-700">
        {label}
      </label>
    </div>
  );
}
